import { SecurityStaticData } from './reducer'

export enum QuoteReliability {
  All = 0,
  HighFillRate,
  Firm
}

export const QuoteReliabilityDisplayNames: Record<string, string> = {
  All: 'All',
  HighFillRate: '90+% Fill Rate',
  Firm: '~Firm Only'
}

export type SelectableSecurityStaticData = SecurityStaticData & {
  isSelectable: boolean
}

export type MiniSecurityFilter = {
  qr?: QuoteReliability
  filterSize?: number
}
